import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_DEPTSTRUCTURE,
  GET_CAMPAIGNPAGE,
  DELETE_CAMPAIGNPAGE,
  UPDATE_CAMPAIGNPAGE,
  ADD_NEW_CAMPAIGNPAGE,
} from "./actionType";

import {
  getCampaignPageSuccess,
  getCampaignPageFail,
  deleteCampaignPageSuccess,
  deleteCampaignPageFail,
  updateCampaignPageSuccess,
  updateCampaignPageFail,
  addCampaignPageSuccess,
  addCampaignPageFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getCampaignPageApi,
  updateCampaignPageApi,
  deleteCampaignPageApi,
  addNewCampaignPageApi
} from "../../helpers/backend_helper";

function* getCampaignPage({ payload: campaignPage , path}) {
  try {
    const response = yield call(getCampaignPageApi, campaignPage, path);
    yield put(getCampaignPageSuccess(GET_CAMPAIGNPAGE, response.data));
  } catch (error) {
    yield put(getCampaignPageFail(GET_CAMPAIGNPAGE, error));
  }
}

// function* getDeptStructure({ payload: campaignPage , path}) {
//   try {
//     const response = yield call(getCampaignPageApi, campaignPage, path);
//     yield put(getCampaignPageSuccess(GET_DEPTSTRUCTURE, response.data));
//   } catch (error) {
//     yield put(getCampaignPageFail(GET_DEPTSTRUCTURE, error));
//   }
// }

function* onUpdateCampaignPage({ payload: campaignPage }) {
  try {
    const response = yield call(updateCampaignPageApi, campaignPage);
    yield put(updateCampaignPageSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateCampaignPageFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCampaignPage({ payload: campaignPage }) {
  try {
    const response = yield call(deleteCampaignPageApi, campaignPage);
    yield put(deleteCampaignPageSuccess({ campaignPage, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCampaignPageFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCampaignPage({ payload: campaignPage }) {
  try {
    const response = yield call(addNewCampaignPageApi, campaignPage);
    yield put(addCampaignPageSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCampaignPageFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

// export function* watchGetDeptStructureAll() {
//   yield takeEvery(GET_DEPTSTRUCTURE, getDeptStructure);
// }

export function* watchGetCampaignPage() {
  yield takeEvery(GET_CAMPAIGNPAGE, getCampaignPage);
}

export function* watchUpdateCampaignPage() {
  yield takeEvery(UPDATE_CAMPAIGNPAGE, onUpdateCampaignPage);
}

export function* watchDeleteCampaignPage() {
  yield takeEvery(DELETE_CAMPAIGNPAGE, onDeleteCampaignPage);
}

export function* watchAddNewCampaignPage() {
  yield takeEvery(ADD_NEW_CAMPAIGNPAGE, onAddNewCampaignPage);
}

function* campaignPageSaga() {
  yield all([
    // fork(watchGetDeptStructureAll),
    fork(watchGetCampaignPage),
    fork(watchDeleteCampaignPage),
    fork(watchUpdateCampaignPage),
    fork(watchAddNewCampaignPage)
  ]);
}

export default campaignPageSaga;
